(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[929],{

/***/ 6283:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[productKey]/[slug]",
      function () {
        return __webpack_require__(3894);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var _Text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6462);
/* harmony import */ var _Box_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(825);
/* harmony import */ var _Box_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Box_module_scss__WEBPACK_IMPORTED_MODULE_7__);









function Box(_param) {
    var className = _param.className, children = _param.children, animated = _param.animated, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "animated"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_Box_module_scss__WEBPACK_IMPORTED_MODULE_7___default().box), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_Box_module_scss__WEBPACK_IMPORTED_MODULE_7___default().animated), animated), className)
    }, others), {
        children: typeof children === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: children
        }) : children
    }));
};


/***/ }),

/***/ 5358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IndexWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./components/Container/Container.tsx
var Container = __webpack_require__(6872);
// EXTERNAL MODULE: ./components/Title/Title.tsx
var Title = __webpack_require__(2693);
// EXTERNAL MODULE: ./components/Text/Text.tsx
var Text = __webpack_require__(6462);
// EXTERNAL MODULE: ./components/Anchor/Anchor.tsx
var Anchor = __webpack_require__(2029);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./mockdata/index.ts
var mockdata = __webpack_require__(4600);
;// CONCATENATED MODULE: ./util/locales.ts
var locales = [
    {
        name: "Albanian",
        value: "sq"
    },
    {
        name: "Arabic",
        value: "ar"
    },
    {
        name: "Armenian",
        value: "hy"
    },
    {
        name: "Azerbaijani",
        value: "az"
    },
    {
        name: "Bosnian",
        value: "bs"
    },
    {
        name: "Bulgarian",
        value: "bg"
    },
    {
        name: "Chinese Simplified",
        value: "cn"
    },
    {
        name: "Chinese Traditional",
        value: "zh-TW"
    },
    {
        name: "Croatian",
        value: "hr"
    },
    {
        name: "Czech",
        value: "cs"
    },
    {
        name: "Danish",
        value: "da"
    },
    {
        name: "German",
        value: "de"
    },
    {
        name: "Dutch",
        value: "nl"
    },
    {
        name: "English",
        value: "en"
    },
    {
        name: "Estonian",
        value: "et"
    },
    {
        name: "Finnish",
        value: "fi"
    },
    {
        name: "French",
        value: "fr"
    },
    {
        name: "Japanese",
        value: "jp"
    },
    {
        name: "Georgian",
        value: "ka"
    },
    {
        name: "Greek",
        value: "el"
    },
    {
        name: "Hebrew",
        value: "iw"
    },
    {
        name: "Hungarian",
        value: "hu"
    },
    {
        name: "Italian",
        value: "it"
    },
    {
        name: "Kazakh",
        value: "kk"
    },
    {
        name: "Korean",
        value: "kr"
    },
    {
        name: "Latvian",
        value: "lv"
    },
    {
        name: "Lithuanian",
        value: "lt"
    },
    {
        name: "Maltese",
        value: "mt"
    },
    {
        name: "Norwegian",
        value: "no"
    },
    {
        name: "Persian",
        value: "fa"
    },
    {
        name: "Polish",
        value: "pl"
    },
    {
        name: "Portuguese",
        value: "pt"
    },
    {
        name: "Portuguese (Brazil)",
        value: "pt-BR"
    },
    {
        name: "Romanian",
        value: "ro"
    },
    {
        name: "Russian",
        value: "ru"
    },
    {
        name: "Serbian",
        value: "sr"
    },
    {
        name: "Slovak",
        value: "sk"
    },
    {
        name: "Slovenian",
        value: "sl"
    },
    {
        name: "Spanish",
        value: "es"
    },
    {
        name: "Swahili",
        value: "sw"
    },
    {
        name: "Swedish",
        value: "sv"
    },
    {
        name: "Thai",
        value: "th"
    },
    {
        name: "Turkish",
        value: "tr"
    },
    {
        name: "Ukrainian",
        value: "uk"
    },
    {
        name: "Vietnamese",
        value: "vi"
    }, 
];
/* harmony default export */ var util_locales = (locales);

// EXTERNAL MODULE: ./components/Button/Button.module.scss
var Button_module = __webpack_require__(5474);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./components/Button/Button.tsx






function Button(_param) {
    var className = _param.className, others = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return(//@ts-ignore
    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)({
        type: "button",
        className: (0,clsx_m/* default */.Z)((Button_module_default()).button, className)
    }, others)));
};

// EXTERNAL MODULE: ./components/LanguageSelector/LanguageSelector.module.scss
var LanguageSelector_module = __webpack_require__(2898);
var LanguageSelector_module_default = /*#__PURE__*/__webpack_require__.n(LanguageSelector_module);
;// CONCATENATED MODULE: ./components/LanguageSelector/LanguageSelector.tsx











function LanguageSelector(_param) {
    var className = _param.className, locale = _param.locale, localeCountry = _param.localeCountry, others = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "locale",
        "localeCountry"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(localeCountry ? localeCountry === null || localeCountry === void 0 ? void 0 : localeCountry.split("-")[0] : locale), value = ref[0], setValue = ref[1];
    var query = (0,react.useMemo)(function() {
        var clone = (0,_object_spread/* default */.Z)({}, router.query);
        delete clone.locale_country;
        return clone;
    }, [
        router.query
    ]);
    console.log(localeCountry);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)((LanguageSelector_module_default()).languageSelector, className)
    }, others), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                value: value,
                onChange: function(e) {
                    return setValue(e.target.value);
                },
                className: (LanguageSelector_module_default()).select,
                children: util_locales.sort(function(a, b) {
                    return a.name > b.name ? 1 : -1;
                }).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: item.value,
                        children: item.name
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                onClick: function() {
                    return router.push({
                        pathname: router.pathname,
                        query: (0,_object_spread/* default */.Z)({}, query, localeCountry ? {
                            locale_country: "".concat(value, "-").concat(localeCountry.split("-")[1])
                        } : {
                            locale: value
                        })
                    });
                },
                children: mockdata/* selector.select_language */.nZ.select_language
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/IndexWrapper/IndexWrapper.module.scss
var IndexWrapper_module = __webpack_require__(3796);
var IndexWrapper_module_default = /*#__PURE__*/__webpack_require__.n(IndexWrapper_module);
;// CONCATENATED MODULE: ./components/IndexWrapper/IndexWrapper.tsx













function IndexWrapper(_param) {
    var className = _param.className, locale = _param.locale, name = _param.name, hide_language_selector = _param.hide_language_selector, hide_back_link = _param.hide_back_link, backLink = _param.backLink, labels = _param.labels, children = _param.children, disableNotePadding = _param.disableNotePadding, localeCountry = _param.localeCountry, others = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "locale",
        "name",
        "hide_language_selector",
        "hide_back_link",
        "backLink",
        "labels",
        "children",
        "disableNotePadding",
        "localeCountry"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)((IndexWrapper_module_default()).container, className)
    }, others), {
        children: [
            !hide_back_link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, backLink), {
                className: (IndexWrapper_module_default()).backLink
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                order: 1,
                className: (IndexWrapper_module_default()).title,
                children: name
            }),
            !hide_language_selector && /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector, {
                className: (IndexWrapper_module_default()).language,
                locale: locale,
                localeCountry: localeCountry
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                component: "div",
                className: (0,clsx_m/* default */.Z)((IndexWrapper_module_default()).note, (0,_define_property/* default */.Z)({}, (IndexWrapper_module_default()).noPadding, disableNotePadding)),
                dangerouslySetInnerHTML: {
                    __html: labels.notes
                }
            })
        ]
    }));
};


/***/ }),

/***/ 2740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Manual; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6010);
/* harmony import */ var _Title_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2693);
/* harmony import */ var _Anchor_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2029);
/* harmony import */ var _Box_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3509);
/* harmony import */ var _Manual_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4068);
/* harmony import */ var _Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9__);










function Manual(_param) {
    var className = _param.className, title = _param.title, titleAppendix = _param.titleAppendix, manual = _param.manual, manuals = _param.manuals, previousUrl = _param.previousUrl, previousLabel = _param.previousLabel, _withPrevious = _param.withPrevious, withPrevious = _withPrevious === void 0 ? false : _withPrevious, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "title",
        "titleAppendix",
        "manual",
        "manuals",
        "previousUrl",
        "previousLabel",
        "withPrevious"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default().manual), className)
    }, others), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Title_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                order: 3,
                className: (_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title),
                children: [
                    title,
                    titleAppendix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default().titleAppendix),
                        children: titleAppendix
                    })
                ]
            }),
            manual && manual.file && manual.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default().manualItem),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Anchor_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: manual.file,
                    target: "_blank",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        className: (_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default().box),
                        children: manual.title
                    })
                })
            }),
            manuals && manuals.filter(function(manual) {
                return manual.title && manual.file;
            }).map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default().manualItem),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Anchor_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        href: item.file,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: (_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default().box),
                            children: item.title
                        })
                    })
                }, index);
            }),
            previousUrl && withPrevious && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default().previousManualWrapper),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Anchor_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: previousUrl,
                    className: (_Manual_module_scss__WEBPACK_IMPORTED_MODULE_9___default().previousManual),
                    children: previousLabel
                })
            })
        ]
    }));
};


/***/ }),

/***/ 1398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NotFoundPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _mockdata__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4600);
/* harmony import */ var _IndexWrapper_IndexWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5358);




function NotFoundPage(param) {
    var locale = param.locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_IndexWrapper_IndexWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        locale: locale,
        labels: _mockdata__WEBPACK_IMPORTED_MODULE_2__/* .product */ .O7,
        name: _mockdata__WEBPACK_IMPORTED_MODULE_2__/* .product.error */ .O7.error,
        backLink: {
            href: "/",
            children: _mockdata__WEBPACK_IMPORTED_MODULE_2__/* .product.back_to_list */ .O7.back_to_list
        },
        disableNotePadding: true
    });
};


/***/ }),

/***/ 5675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PreviousPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Manual_Manual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2740);
/* harmony import */ var _mockdata__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4600);
/* harmony import */ var _IndexWrapper_IndexWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5358);





function PreviousPage(param) {
    var locale = param.locale, name = param.name, manuals = param.manuals, labels = param.labels, backLink = param.backLink, localeCountry = param.localeCountry;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_IndexWrapper_IndexWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        labels: labels,
        backLink: backLink,
        name: name,
        locale: locale,
        localeCountry: localeCountry,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Manual_Manual__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            manuals: manuals,
            title: _mockdata__WEBPACK_IMPORTED_MODULE_3__/* .product.previous_manuals */ .O7.previous_manuals
        })
    });
};


/***/ }),

/***/ 2693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Title; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var _Text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6462);
/* harmony import */ var _Title_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4123);
/* harmony import */ var _Title_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Title_module_scss__WEBPACK_IMPORTED_MODULE_7__);








function Title(_param) {
    var className = _param.className, component = _param.component, _order = _param.order, order = _order === void 0 ? 3 : _order, children = _param.children, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "component",
        "order",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        component: component || "h".concat(order),
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_Title_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title), [
            (_Title_module_scss__WEBPACK_IMPORTED_MODULE_7___default())["h".concat(order)]
        ], className)
    }, others), {
        children: children
    }));
};


/***/ }),

/***/ 3894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ SlugPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_PreviousPage_PreviousPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var _components_NotFoundPage_NotFoundPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1398);
/* harmony import */ var _mockdata__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4600);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);








var __N_SSP = true;
function SlugPage(param) {
    var data = param.data, locale = param.locale, slug = param.slug, localeCountry = param.localeCountry;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    return !data ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NotFoundPage_NotFoundPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        locale: locale || "en"
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PreviousPage_PreviousPage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data), {
        locale: locale || "en",
        labels: _mockdata__WEBPACK_IMPORTED_MODULE_4__/* .product */ .O7,
        localeCountry: localeCountry,
        backLink: {
            href: router.asPath.replace("/".concat(slug), ""),
            children: _mockdata__WEBPACK_IMPORTED_MODULE_4__/* .product.back_to_product */ .O7.back_to_product
        }
    }));
};


/***/ }),

/***/ 825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__a3mk0","animated":"Box_animated__hI1Sl"};

/***/ }),

/***/ 5474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__30ukX"};

/***/ }),

/***/ 3796:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"IndexWrapper_container__J4yG1","title":"IndexWrapper_title__1In9G","language":"IndexWrapper_language__gQ4g5","backLink":"IndexWrapper_backLink__vWvBC","note":"IndexWrapper_note__IjnSt","noPadding":"IndexWrapper_noPadding__cUUG_"};

/***/ }),

/***/ 2898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"LanguageSelector_languageSelector__WtqNz","select":"LanguageSelector_select__HOxGb"};

/***/ }),

/***/ 4068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"manual":"Manual_manual__LsfaR","title":"Manual_title__j16d_","titleAppendix":"Manual_titleAppendix__83ZQk","box":"Manual_box__Rthst","manualItem":"Manual_manualItem__rC6z0","previousManualWrapper":"Manual_previousManualWrapper__zgzyE","previousManual":"Manual_previousManual__NVdtF"};

/***/ }),

/***/ 4123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__SEYIO","h1":"Title_h1__KJ_pk","h2":"Title_h2__aRxAG","h3":"Title_h3__9Rm_S"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(6283); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);